export default {
  title: '數據看板',
  loadingStatus: '數據載入中',
  syncedStatus: '數據已同步',
  refresh: '重新整理',
  notRefreshed: '尚未重新整理',
  lastRefreshedAt: '最後重新整理 {time}',
  todayScanCount: '今日掃碼個數',
  todayNewMembers: '今日新增會員',
  totalScanCount: '掃碼總個數',
  totalMembers: '會員總數',
  ratioUp: '環比↑ {value}%',
  quickActions: '快捷操作',
  actionProducts: '產品管理',
  actionCodeDisable: '二維碼禁用',
  actionActivity: '活動管理',
  actionMemberList: '會員列表',
  actionPointsMall: '積分商城',
  scanTrend: '掃碼趨勢',
  thisWeek: '本週',
  thisMonth: '本月',
  realtimeScanRecords: '實時掃碼記錄',
  scanTime: '掃碼時間',
  userName: '用戶名稱',
  scanRegion: '掃碼國家/地區',
  legendScanCount: '掃碼個數',
  legendScanUsers: '掃碼人數',
  legendWinners: '中獎人數',
  unit: '個',
};
